import React from 'react';

export const ImageWithPlaceholder = ({ src, alt }) => {
  const placeholder = `/calendario/placeholder.gif`;

  const handleError = (event) => {
    event.target.src = placeholder;
  };

  return (
    <img 
      src={src} 
      alt={alt} 
      onError={handleError} 
    />
  );
};